import { MoneyIcon } from "assets/icons";

export enum OrderPaymentMethod {
  Card = "Card",
  MobileMoney = "MobileMoney",
  CashOnDelivery = "CashOnDelivery"
}

export const OrderPaymentMethods = {
  [OrderPaymentMethod.Card]: {
    label: "Card",
    value: OrderPaymentMethod.Card,
    icon: <></>
  },
  [OrderPaymentMethod.MobileMoney]: {
    label: "Mobile Money",
    value: OrderPaymentMethod.MobileMoney,
    icon: <></>
  },
  [OrderPaymentMethod.CashOnDelivery]: {
    label: "Cash on Delivery",
    value: OrderPaymentMethod.CashOnDelivery,
    icon: <MoneyIcon />
  }
};
